export class UserManagementModel {
    public id: any;
    public role_name: string;
    public role_desc: string;
    public email: string;
    public role_status: string;

    public page_nav_id: any;
    public nav_page_name: string;
    public nav_page_desc: string;
    public page_order: any;
    public parent_page_id: any;
    public submenus: string[];

    public mapping_id: any;
    public userroleid: number;
    public page_id: number;
    public view_acc: boolean;
    public edit_acc: boolean;
    public del_acc: string;
    public status: string;

    public comment: string;
    public created_dt: Date;
    public created_by: string;
    public updated_dt: Date;
    public updated_by: string;

    public sub_page_id: any;
    public sub_nav_page_name: string;
    public sub_nav_page_desc: string;
    public sub_created_dt: Date;
    public nav_page_route: string;
    public editMode: boolean;
    public role_id: number;
    public access_level: number;

    constructor() {
        this.id = '';
        this.role_name = '';
        this.role_desc = '';
        this.email = '';
        this.role_status = '';

        this.page_nav_id = '';
        this.nav_page_name = '';
        this.nav_page_desc = '';
        this.page_order = '';
        this.parent_page_id = '';
        this.submenus = [];

        this.mapping_id = '';
        this.userroleid = 0;
        this.page_id = 0;
        this.view_acc = true;
        this.edit_acc = true;
        this.del_acc = '';
        this.status = '';

        this.comment = '';
        this.created_dt = null;
        this.created_by = '';
        this.updated_dt = null;
        this.updated_by = '';

        this.sub_page_id = '';
        this.sub_nav_page_name = '';
        this.sub_nav_page_desc = '';
        this.sub_created_dt = null;
        this.nav_page_route = '';
        this.editMode = true;
        this.role_id = 0;
        this.access_level = 0;
    }
}
